import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
	DataGrid,
	GridToolbar,
	GridToolbarContainer,
	useGridApiEventHandler,
} from "@mui/x-data-grid";

const OfferingTable = (props) => {

	const { allCV } = props;

	// const onMouseEnterRow = (event) => {
	//   const id = event.currentTarget.getAttribute("data-id");

	//   setHoveredRow(id);
	// };

	// const onMouseLeaveRow = (event) => {
	//   setHoveredRow(null);
	// };
	const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
	const [offers, setOffers] = useState([]);

	const fetchOffers = async (allCV) => {
		let api_path = `${host}/api/v1/offerings/`
		if (allCV) {
			api_path = api_path + '?cash_voucher=1'
		}
		const response = await fetch(api_path, {
			method: "GET" /* GET, POST, PUT, DELETE, etc. */,
			headers: {
				"Content-Type": "application/json",
				accessToken: localStorage.getItem("accessToken"),
			},
		}).catch((err) => {
			// console.log(err.mesage);
		});

		const json = await response.json();
		setOffers(json.data);
	};

	useEffect(() => {
		fetchOffers(allCV);
	}, [allCV])

	let columns = [
		{ field: "id", headerName: "ID", width: 90 },
		{
			field: "brand_name",
			headerName: "Brand Name",
			sortable: true,
			width: 200,
		},
		{
			field: "discount",
			headerName: "Discount",
			sortable: false,
			width: 80,
			editable: false,
		},
		{
			field: "discount_type",
			headerName: "Discount Type",
			sortable: true,
			width: 120,
		},
		{
			field: "type",
			headerName: "Type",
			sortable: true,
			width: 150,
			editable: false,
		},
		{
			field: "details",
			headerName: "Details",
			sortable: true,
			width: 250,
			editable: true,
		},
		{
			field: "validity",
			headerName: "Validity",
			type: "dateTime",
			sortable: true,
			width: 200,
			editable: true,
		},
		{
			field: "tags",
			headerName: "Tags",
			sortable: true,
			width: 200,
			editable: true,
		},

		// {
		// 	field: "coin",
		// 	headerName: "Coin",
		// 	sortable: true,
		// 	width: 80,
		// 	editable: true,
		// },
		{
			field: "status",
			headerName: "Status",
			sortable: true,
			width: 100,
			editable: true,
		}

	];

	// console.log("line no 206offers",offers)
	const rows = offers.map((offer) => ({
		id: offer.offering_id,
		discount_type: offer.discount_type,
		discount: offer.discount,
		type: offer.type,
		// tag: offer.tag,
		validity: offer.validity
			? new Date(offer.validity).toLocaleString({ timeZone: "Asia/Kolkata" })
			: offer.validity,
		brand_name: offer.brand_name,
		// coin: offer.coin,
		created_at: offer.created_at,
		details: offer.details,
		tags: offer.tag.map(obj => obj.name).join(', '),
		status: offer.status ? "Active" : "Inactive"
	}));

	// console.log(rows,columns)
	const handleSelect = (e) => {
		props.handleRowSelection(e)
	}



	return (
		// <Box sx={{ height: 500, width: "100%" }}>
		<Box style={{ height: "75vh", width: "90%", margin: '10px auto' }}>
			<DataGrid
				columnVisibilityModel={{
					id: false,
					// source_business_id:false,
				}}
				rowHeight={35}
				pageSize={10}
				rowsPerPageOptions={[10]}
				components={{
					Toolbar: GridToolbar,
				}}
				//checkboxSelection
				rows={rows}
				columns={columns}
				initialState={{ pinnedColumns: { right: ["actions"] } }}
				checkboxSelection
				onSelectionModelChange={(e) => handleSelect(e)}
				// componentsProps={{
				//   row: {
				//     onMouseEnter: onMouseEnterRow,
				//     onMouseLeave: onMouseLeaveRow,
				//   },
				// }}
				sx={{
					'& [aria-label="Select all rows"], & [aria-label="Unselect all rows"]': {
						display: 'none',
						pointerEvents: 'none',
						opacity: 0.5, // optional visual cue before hiding
					},
					"& .MuiDataGrid-iconSeparator": {
						display: "none",
					},
					"& .MuiDataGrid-pinnedColumnHeaders": {
						boxShadow: "none",
						backgroundColor: "transparent",
					},
					"& .MuiDataGrid-pinnedColumns": {
						boxShadow: "none",
						backgroundColor: "transparent",
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					},
					"& .MuiDataGrid-row": {
						cursor: "pointer",
						"&:hover": {
							backgroundColor: "whitesmoke",
						},
						"&:first-child": {
							borderTop: "1px solid rgba(224, 224, 224, 1)",
						},
					},
					"& .MuiDataGrid-cell:focus": {
						outline: "none",
					},
					"& .MuiDataGrid-cell:focus-within": {
						outline: "none",
					},
				}}
			/>
		</Box>
	);
};

export default OfferingTable;
